import 'COMMON';
import 'Vendor/polifill-object-fit-images/polifill-object-fit-images';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { oLike } from 'Lib/like/like';
import 'Bem/journal/text-insert/text-insert';
import 'Bem/journal/gallery/gallery';
import 'Bem/journal/text-insert-card/text-insert-card';
import 'Bem/journal/articles/articles';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/book/book';
import 'Bem/journal/article-t/article-t';
import 'Bem/journal/article-share/article-share';
import 'Bem/site/popup-subscribe/popup-subscribe';
import 'Bem/site/reviews/reviews';
import 'Bem/site/form-bg/form-bg';
import 'Bem/site/spoiler/spoiler';
import 'Bem/journal/text-insert-min/text-insert-min';
import 'Bem/journal/video/video';
import 'Bem/site/copy/copy';
import { Reactions } from 'Lib/reactions/reactions';

const $body = $('body');
let reactions = new Reactions(document.querySelectorAll('.reactions'));

reactions.init();

$body.on('init.fastViewBook', () => {
    reactions = new Reactions(document.querySelectorAll('.reactions'));
    reactions.init();
});

svgSpriteLoader('/site/news/svg/sprite.svg?v=20180320');
oLike.init('.js-book-like, .js-article-like');